import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface WizardStepProps {
  isActive: boolean;
  direction?: 'forward' | 'backward';
  children: ReactNode;
  className?: string;
}

export function WizardStep({
  isActive,
  direction = 'forward',
  children,
  className,
}: WizardStepProps) {
  if (!isActive) return null;

  return (
    <div
      className={cn(
        'animate-in duration-300',
        direction === 'forward' ? 'slide-in-from-right-4' : 'slide-in-from-left-4',
        'fade-in-0',
        className
      )}
    >
      {children}
    </div>
  );
}
